import { Injectable } from "@angular/core";
import { MessageTemplatesService } from "@app/core/services/message-templates/message-templates.service";
import { Action, Selector, State, StateContext } from "@ngxs/store";
import { tap } from "rxjs/operators";
import { GetTemplates, TemplateStateModel } from "./index";


@State<TemplateStateModel>({
    name: 'Template',
    defaults: {
        templates: {},
        activePage: 1,
    }
})

@Injectable()
export class TemplateState {

    constructor(private templateService: MessageTemplatesService) {
    }

    @Selector()
    static getTemplatesList(state: TemplateStateModel) {
        return state.templates;
    }

    @Selector()
    static getActivePage(state: TemplateStateModel) {
        return state.activePage;
    }

    @Action(GetTemplates)
    getTemplates({getState, setState}: StateContext<TemplateStateModel>, { pageIdex }: GetTemplates) {
        return this.templateService.templatesList(pageIdex).pipe(tap((res: any) => {
            const state = getState;
            setState({
                ...state,
                templates: res['data']['template'],
                activePage: pageIdex
            })
        }))
    }


}